module.exports = __webpack_public_path__ + "static/media/PORTADA_CICLO_4_TECNOLÓGICO.6a510768.jpg";